export default "__VITE_ASSET__c6f6c3bd__"